//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { ExcelRenderer } from "react-excel-renderer";
import { APICall, HttpMethod } from "../../../../Helpers/Network/APICalls";
// import { AutoCompleteValue } from "../../../../Components/InputForm/InputForm";
import InputForm, {
  AutoCompleteValue,
} from "../../../../Components/InputForm/InputForm";
import { LoaderContext, getContext } from "../../../../Helpers/Context/Context";
import notify, { ToastType } from "../../../../Helpers/ToastNotification";
import axios from "axios";
import { fetchAuthToken } from "../../../../Helpers/Network/OAuthHandler";
import fileDownload from "js-file-download";
import Modal from "react-modal";
import {
  DownloadMemberTableRecord,
  UploadMemberUpdatedFile,
  CommonDropdownData,
  DownloadMemberRecoveryReport,
} from "../../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../../Helpers/Enums/ApiStatus";
import SelectForm from "../../../../Components/SelectForm/SelectForm";
import "../MonthlyCommonDashboard/MonthlyCommonDashboard.css";
import MultiSelect from "../../../../Components/SelectForm/MultiSelect";

Modal.setAppElement("#root"); // Use the selector for your root element

const MemberTableReco = () => {
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [UploadExcelFile, setUploadExcelFile] = useState("No File Uploaded");
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState([]);
  const [modalIsOpenError, setModalIsOpenError] = useState(false);
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitcode, setUnitCode] = useState([]);
  const [fyear, SetFyear] = useState();
  const [monthId, setMonthId] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  const MONTHS_ENUM = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };
  useEffect(() => {
    showLoader();
    getDropDownDataApiCall();
    hideLoader();
  }, []);

  const selectOnChange = (event: any, apiFieldName: any) => {
    showLoader();
    if (apiFieldName === "UnitCode") {
      setUnitCode(event);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        unitcode_isEmpty: "",
      }));
    }
    hideLoader();
  };

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "unitcodedd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;
      await setUnitCodeOptions([...options]);
    } else {
      await setUnitCodeOptions([]);
    }
    hideLoader();
  };

  const onUploadValidationCheck = () => {
    setFormErrors({});
    formErrorObj = {};
    if (
      !UploadExcelFile ||
      UploadExcelFile === "" ||
      UploadExcelFile === "No File Uploaded"
    ) {
      formErrorObj["bulkUpload_isEmpty"] = "Please upload file.";
    }
    // if (!unitcode || unitcode.length <= 0) {
    //   formErrorObj["unitcode_isEmpty"] = "Unit code can not be empty";
    // }
    setFormErrors(formErrorObj);
  };

  const openModalError = () => {
    setModalIsOpenError(true);
  };

  const closeModalError = () => {
    setModalIsOpenError(false);
    clearFunction();
  };

  const openModal = (fYear, Month, fyearid) => {
    SetFyear(fyearid);
    setMonthId(Month);
    setUnitCode(null);
    setModalIsOpen(true);
    clearFunction();
    setSelectedFileName("");
  };

  const closeModal = () => {
    setModalIsOpen(false);
    clearFunction();
  };

  const clearFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setUploadExcelFile("No File Uploaded");
    setSelectedFile(null);
    setSelectedFileName("No File Chosen");
  };

  // const setDatas = () => {

  // }

  const bulkUploadRequestExcelFileChange = (param: any) => {
    
    setSelectedFileName("");
    let bulkUploadRequestExcelFile = param.target.files[0];
    if (param.target.files[0]) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        bulkUpload_isEmpty: "",
      }));
    }
    if (bulkUploadRequestExcelFile) {
      setSelectedFileName(bulkUploadRequestExcelFile.name); // Update the file name in state
    }
    if (param.target.files.length > 0) {
      if (
        bulkUploadRequestExcelFile.size &&
        bulkUploadRequestExcelFile.size <= 31457280
      ) {
        let fileExtLength = bulkUploadRequestExcelFile.name.split(".");
        if (fileExtLength.length === 2) {
          let fileExtensionName = bulkUploadRequestExcelFile.name
            .split(".")[1]
            .toLowerCase();
          if (fileExtensionName === "xlsx") {
            formErrorObj = {};
            setFormErrors({});

            setUploadExcelFile(bulkUploadRequestExcelFile.name);
            ExcelRenderer(bulkUploadRequestExcelFile, async (err, resp) => {
              if (err) {
                clearFunction();
                notify(ToastType.Error, err);
              } else {
                if (
                  resp.rows[0][0] != "Token No." &&
                  resp.rows[0][1] != "Personnel Number" &&
                  resp.rows[0][2] != "Member No." &&
                  resp.rows[0][3] != "Unit Code" &&
                  resp.rows[0][4] != "Unit Name" &&
                  resp.rows[0][5] != "Member Name" &&
                  resp.rows[0][6] != "Opening SC" &&
                  resp.rows[0][7] != "Opening CD" &&
                  resp.rows[0][8] != "Opening FD" &&
                  resp.rows[0][9] != "Opening AFD" &&
                  resp.rows[0][10] != "Opening MBF" &&
                  resp.rows[0][11] != "Opening LTL" &&
                  resp.rows[0][12] != "Opening ALTL" &&
                  resp.rows[0][13] != "Opening STL" &&
                  resp.rows[0][14] != "FI SC" &&
                  resp.rows[0][15] != "FI CD" &&
                  resp.rows[0][16] != "FI FD" &&
                  resp.rows[0][17] != "FI AFD" &&
                  resp.rows[0][18] != "FI MBF" &&
                  resp.rows[0][19] != "FI LTL" &&
                  resp.rows[0][20] != "FI ALTL" &&
                  resp.rows[0][21] != "FI STL" &&
                  resp.rows[0][22] != "Closing SC" &&
                  resp.rows[0][23] != "Closing CD" &&
                  resp.rows[0][24] != "Closing FD" &&
                  resp.rows[0][25] != "Closing AFD" &&
                  resp.rows[0][26] != "Closing MBF" &&
                  resp.rows[0][27] != "Closing LTL" &&
                  resp.rows[0][28] != "Closing ALTL" &&
                  resp.rows[0][29] != "Closing STL" &&
                  resp.rows[0][23] != "9077 - SC" &&
                  resp.rows[0][24] != "9077 - CD" &&
                  resp.rows[0][25] != "9077 - FD" &&
                  resp.rows[0][26] != "9077 - AFD" &&
                  resp.rows[0][27] != "9077 - MBF" &&
                  resp.rows[0][28] != "9077 - LTL" &&
                  resp.rows[0][29] != "9077 - ALTL" &&
                  resp.rows[0][30] != "9077 - STL" &&
                  resp.rows[0][31] != "Diff. - SC" &&
                  resp.rows[0][32] != "Diff. - CD" &&
                  resp.rows[0][33] != "Diff. - FD" &&
                  resp.rows[0][34] != "Diff. - AFD" &&
                  resp.rows[0][35] != "Diff. - MBF" &&
                  resp.rows[0][36] != "Diff. - LTL" &&
                  resp.rows[0][37] != "Diff. - ALTL" &&
                  resp.rows[0][38] != "Diff. - STL"
                ) {
                  clearFunction();
                  setModalIsOpen(false);
                  notify(
                    ToastType.Error,
                    "Invalid excel file, Please refer sample excel format."
                  );
                } else {
                  setSelectedFile(bulkUploadRequestExcelFile);
                  // await htmlEncodeAllFields(resp.rows);
                }
              }
            });
          } else {
            clearFunction();
            setModalIsOpen(false);
            notify(ToastType.Error, "You should uplaod excel file only.");
          }
        } else {
          clearFunction();
          setModalIsOpen(false);
          notify(
            ToastType.Error,
            "You should upload valid excel file only, file name contains multiple extensions."
          );
        }
      } else {
        clearFunction();
        notify(ToastType.Error, "File size should not be greater than 30 MB.");
      }
    } else {
      clearFunction();
      setModalIsOpen(false);
      notify(ToastType.Error, "Invalid file selected");
    }
  };

  const downloadSampleExcel = async () => {
    const params = {
      FinancialYear: fyear,
      Month: MONTHS_ENUM[monthId],
      // UnitCode:
      //   unitcode && unitcode.length > 0
      //     ? unitcode.map(({ value }) => value).toString()
      //     : " ",
    };
    let token = await fetchAuthToken();

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: DownloadMemberTableRecord,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
       
        fileDownload(response.data, `MembertableReco_Sample.xlsx`);
        setModalIsOpenError(false);
        setModalIsOpen(false);
      })
      .catch((error) => {
       
        setModalIsOpenError(false);
        setModalIsOpen(false);
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const handleUpload = async () => {
    
  
    let Month = MONTHS_ENUM[monthId];
    await onUploadValidationCheck();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });
    // let fileInBase64 = "";
    if (isEmpty === true) {
     

      const formData = new FormData();
      // 'file' should match your backend's file input name
      formData.append("file", selectedFile);
      formData.append("ImportExcelUserId", context?.MemberId);

      // Append fields of ReportsEntity
      formData.append("Param.FinancialYear", fyear);
      formData.append("Param.Month", Month);

      var data = await APICall(
        // UploadExcelMemberTableReco
        UploadMemberUpdatedFile,
        formData,
        HttpMethod.POST,
        false,
        "",
        true
      );
      if (data.Message === "Ok") {
        closeModal();
        clearFunction();
        setModalIsOpen(false);
        // fileDownload(response.data, `Sample_Location.xlsx`);
        notify(ToastType.Success, "file uploaded success!");
      } else if (
        data.Message === "VALIDATION_ERROR" ||
        data.Message === "error"
      ) {
        openModalError();
        setErrorMessage(data);
      } else if (data.Message === "Something Went Wrong.") {
        setModalIsOpen(false);
        notify(ToastType.Error, data.Data?.Data?.Message || data?.Data?.Data);
      } else {
        setModalIsOpen(false);
        notify(ToastType.Error, JSON.stringify(data?.Message));
      }
    }
  };

  const ExcelImport = (yearId, monthId) => {
    return (
      <>
        <div className="ModalSize">
          <Modal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="File Upload Modal"
            style={{
              content: {
                width: "35%", // Adjust this value as needed
                height: "17em", // Adjust this value as needed
                margin: "auto", // Center the modal horizontally
              },
            }}
          >
            <div className="alignment">
              {/* <div className="col-lg-12 p-0">
                <div
                  className="row"
                  style={{ marginRight: "5px", float: "right" }}
                >
                  <a
                    onClick={downloadSampleExcel}
                    target="_blank"
                    className="btn btn-cancel"
                  >
                    <i className="fa fa-download"></i> Excel File
                  </a>
                </div>
              </div> */}
              <div className="col-lg-12 p-0">
                <div className="row">
                  <div
                    className="col-lg-12 col-md-12"
                    style={{ marginBottom: "15px" }}
                  >
                    <div className="form-group">
                      <label className="col-form-label">Import Excel</label>
                      <sup style={{ fontSize: "13px" }}>*</sup>
                      <input
                        type="file"
                        id="bulkUploadRequestExcelFile"
                        accept=".xlsx"
                        style={{ display: "none" }}
                        onChange={bulkUploadRequestExcelFileChange}
                      />
                      <br></br>
                      <input
                        style={{ width: "350px" }}
                        type="text"
                        value={selectedFileName}
                        readOnly
                        onClick={() =>
                          document
                            .getElementById("bulkUploadRequestExcelFile")
                            .click()
                        }
                      />
                      {/* {selectedFileName && (
                          <p>Selected File: {selectedFileName}</p> // Display the selected file name
                        )} */}
                      <p style={{ color: "red" }}>
                        {formErrors["bulkUpload_isEmpty"]}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 d-flex justify-content-end">
                    <button className="btn btn-submit" onClick={handleUpload}>
                      Upload
                    </button>
                    <button
                      className="btn btn-cancel"
                      onClick={closeModal}
                      style={{ marginLeft: "10px" }}
                    >
                      <i className="far fa-times-circle"></i> Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
        <div className="ModalSize">
          <Modal
            ariaHideApp={false}
            isOpen={modalIsOpenError}
            onRequestClose={closeModalError}
            contentLabel="Error Message"
            style={{
              content: {
                width: "30%", // Adjust this value as needed
                height: "16em", // Adjust this value as needed
                margin: "auto", // Center the modal horizontally
                backgroundColor: "antiquewhite",
              },
            }}
          >
            <div className="col-lg-12 p-0">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  style={{ marginBottom: "15px" }}
                >
                  {errorMessage?.Data?.map((errorMag: any, index: any) => (
                    <p key={index} className="ErrorMessage">
                      {index + 1}. {errorMag}
                    </p>
                  ))}
                </div>
                <div className="col-lg-12 col-md-12">
                  <button
                    className="btn btn-cancel"
                    onClick={closeModalError}
                    style={{ marginLeft: "10px", float: "right" }}
                  >
                    <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <>
      <MonthlyCommonDashboard
        PageName="MemberTableReco"
        ExportToExcelUrl={DownloadMemberRecoveryReport}
        // ExportToExcelUrl={DownloadMemberTableRecord}
        UploadExcel={true} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={ExcelImport}
        openModal={openModal}
        // setDatas={setDatas}
      />
    </>
  );
};

export default MemberTableReco;
